import React from "react";
import ProductCards from "./ProductCards";
import "./SaasSections.css";

export default function ProductsSection() {
  return (
    <section className="saas-section products-section" id="products-section">
      <h2 className="mainHeading1 saas-section__title">OUR PRODUCTS</h2>
      <div className="saas-section__header">
        <p className="saas-section__intro">
          Cloud-native AI SaaS platforms built for HR, education, sales, and enterprise operations.
        </p>
      </div>
      <div className="saas-section__body">
        <ProductCards />
      </div>
    </section>
  );
}
